import { Injectable } from '@angular/core';

export interface ConfirmsUnsavedChanges {
  canDeactivate(): Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class InventoryUnsavedChangesGuard {
  canDeactivate(component: ConfirmsUnsavedChanges): Promise<boolean> | boolean {
    return component?.canDeactivate?.() ?? true;
  }
}
